export default __webpack_public_path__ + "static/media/cancel-flowers.ab3d7455.svg";